// removed by extract-text-webpack-plugin
module.exports = {"performaTagBox":"performaTagBox--f6c9e"};